// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@guestsupply/App/Store/Reducers";
import { getSettingsCollection } from "@guestsupply/App/Store/Selectors/SettingsSelectors";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Link, { LinkPresentationProps } from "@insite/mobius/Link/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    customerServiceEmail: (getSettingsCollection(state) as any).customSettings?.customerServiceEmail,
    unhandledError: (state as CustomAppState).xCommon.unhandledError,
});

type Props = ReturnType<typeof mapStateToProps>;

export interface CustomUnhandledModalErrorMessageStyles {
    errorDetailsTitle?: TypographyProps;
    customerServiceEmail?: LinkPresentationProps;
}
export const customUnhandledModalErrorMessageStyles: CustomUnhandledModalErrorMessageStyles = {};
const styles = customUnhandledModalErrorMessageStyles;

const CustomUnhandledModalErrorMessageContent = ({ customerServiceEmail, unhandledError }: Props) => {
    return (
        <>
            <Typography>{`${siteMessage("API_Error_Popup_Body")}`} </Typography>
            <Link {...styles.customerServiceEmail} href={`mailto: ${customerServiceEmail}`}>
                {customerServiceEmail}
            </Link>
            <Typography {...styles.errorDetailsTitle}>{siteMessage("API_Error_Detail_Title")}</Typography>
            <Typography>{unhandledError}</Typography>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(CustomUnhandledModalErrorMessageContent),
    definition: {
        group: "Common",
        displayName: "Custom Unhandled Error Modal Content",
    },
};

export default widgetModule;
